import { render, staticRenderFns } from "./flaw-detail.vue?vue&type=template&id=b016e1ac&scoped=true"
import script from "./flaw-detail.vue?vue&type=script&lang=js"
export * from "./flaw-detail.vue?vue&type=script&lang=js"
import style0 from "./flaw-detail.vue?vue&type=style&index=0&id=b016e1ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b016e1ac",
  null
  
)

export default component.exports